// extracted by mini-css-extract-plugin
export default {"icon":"Profesorado_icon__SEbuF","name":"Profesorado_name__6Cbad","nuevo":"Profesorado_nuevo__KhOed"};